export default "__VITE_ASSET__4QC5HhgD__"